// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1575":"c62dda96","5756":"c62dda96"}[chunkId] + ".chunk.css";
};